export default __webpack_public_path__ + "static/media/calender.a954a8a2.svg";